import React from "react";
import { Mic, ExternalLink, Sparkles, MessageSquare, Trophy } from "lucide-react";
import { Reveal } from "@/components/Reveal";

export default function SpeakEase() {
  return (
    <div className="relative z-10 pt-28">
      <section className="mx-auto max-w-5xl px-5 py-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-primary-c">SpeakEase</span>
          <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-t mt-4">Speak English with <span className="text-primary-c">Confidence.</span></h1>
          <p className="text-muted-c text-lg mt-5 max-w-2xl">Practice your spoken English with SpeakEase — our AI-powered English learning companion. Learn at your own pace, get instant feedback, and build real confidence for interviews, college and work.</p>
          <a href="https://speakease.in" target="_blank" rel="noreferrer" className="btn-primary inline-flex items-center gap-2 px-7 py-4 mt-8" data-testid="speakease-cta">
            <Mic size={18} /> Try SpeakEase <ExternalLink size={15} />
          </a>
        </Reveal>
        <div className="grid gap-5 sm:grid-cols-3 mt-14">
          {[{ Icon: Sparkles, t: "AI-Powered Practice", d: "Personalised guidance that adapts to your level." },
            { Icon: MessageSquare, t: "Real Conversations", d: "Practice everyday and professional speaking." },
            { Icon: Trophy, t: "Track Progress", d: "See your fluency and confidence grow over time." }].map((f, i) => (
            <Reveal key={i} delay={i * 0.08}>
              <div className="glass card-hover rounded-2xl p-7 h-full">
                <div className="w-12 h-12 rounded-xl flex items-center justify-center mb-5" style={{ background: "rgba(var(--primary-rgb),0.12)" }}>
                  <f.Icon className="text-primary-c" size={24} />
                </div>
                <h3 className="font-display font-bold text-lg text-t">{f.t}</h3>
                <p className="text-muted-c text-sm mt-2">{f.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
